module.exports = __webpack_public_path__ + "img/JAOC_POP_Cheddar_Icon.b53567a0.png";